import PasswordForm from '@/components/organism/Registration/PasswordForm/PasswordForm.container';

export const PasswordFormPage = () => <PasswordForm />;
